module.exports = __webpack_public_path__ + "static/media/card.dd86ce75.png";